(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7652],{

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 81763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 23201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/_internal/for-sale/[address_id]",
      function () {
        return __webpack_require__(65042);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _address_id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box_Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Spritesheet.mjs + 138 modules
var Spritesheet = __webpack_require__(9526);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(11208);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var helpers_useTrackProperty = __webpack_require__(97997);
// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 14 modules
var marketplace_property = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 22 modules
var Header = __webpack_require__(12149);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/breakpoints.mjs
var foundations_breakpoints = __webpack_require__(64863);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(29212);
// EXTERNAL MODULE: ./src/components/shared/hooks/useInView.tsx
var useInView = __webpack_require__(53456);
;// CONCATENATED MODULE: ./src/components/shared/performance/InViewTracker.tsx
/* storybook-check-ignore */ 






var InViewTracker_InViewTrackerBox = function(_param) {
    var onViewChange = _param.onViewChange, children = _param.children, boxProps = _param.boxProps, intersectionOptions = _object_without_properties(_param, [
        "onViewChange",
        "children",
        "boxProps"
    ]);
    var ref = useRef(null);
    var ref1 = useInViewAfterLoad(_object_spread_props(_object_spread({}, intersectionOptions), {
        ref: ref
    })), inView = ref1.inView, entry = ref1.entry;
    var inViewValueRef = useRef(inView);
    useEffect(function() {
        if (!entry || inView == inViewValueRef.current) {
            return;
        }
        inViewValueRef.current = inView;
        onViewChange(inView);
    }, [
        inViewValueRef,
        inView
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref
    }, boxProps), {
        children: children
    }));
};
/* harmony default export */ var InViewTracker = ((/* unused pure expression or super */ null && (InViewTracker_InViewTrackerBox)));

// EXTERNAL MODULE: ./node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(7654);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var lodash_isNumber = __webpack_require__(81763);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var lodash_isString = __webpack_require__(47037);
;// CONCATENATED MODULE: ./src/components/properties/helpers/format.ts



var kebabCase = function(source) {
    return source.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
};
var numberWithCommas = function(n) {
    if ((!isNumber(n) || !!isNaN(n)) && !isString(n)) {
        return;
    }
    var parts = n.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? ".".concat(parts[1]) : "");
};
var format_numberAsDollar = function(n) {
    if (n !== 0 && !n) {
        return "";
    }
    if ("number" === typeof n) {
        // if number is negative, make sure the negative sign is in front of dollar sign
        var negativeSign = n < 0 ? "-" : "";
        return "".concat(negativeSign, "$").concat(numberWithCommas(Math.round(Math.abs(n) * 100) / 100));
    }
    return n;
};
var nameAndInitials = function nameAndInitials(name) {
    if (!name || typeof name !== "string") {
        return;
    }
    var names = name.split(" ");
    var firstName = names[0];
    var firstInitial = names[0].substring(0, 1).toUpperCase();
    var lastInitial;
    if (names.length > 1) {
        lastInitial = names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return [
        firstInitial,
        lastInitial,
        firstName
    ];
};

// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(59431);
;// CONCATENATED MODULE: ./src/components/properties/helpers/useTrackProperty.ts







var initialPropertyContext = {
    property: undefined
};
var PropertyAnalytics = (0,react.createContext)(initialPropertyContext);
var usePropertyAnalytics = function() {
    return useContext(PropertyAnalytics);
};
/**
 * Geenerate the payload for the trackProperty function, exported for testing
 */ function buildPayload(property) {
    var additionalContextualData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, user = arguments.length > 2 ? arguments[2] : void 0;
    var trackPropertyFields = _object_spread({}, (property === null || property === void 0 ? void 0 : property.city) && {
        city: property === null || property === void 0 ? void 0 : property.city
    }, (property === null || property === void 0 ? void 0 : property.state) && {
        state: property === null || property === void 0 ? void 0 : property.state
    }, (property === null || property === void 0 ? void 0 : property.postalCode) && {
        zip: property === null || property === void 0 ? void 0 : property.postalCode
    }, (property === null || property === void 0 ? void 0 : property.displaySlug) && {
        url: property === null || property === void 0 ? void 0 : property.displaySlug
    }, (property === null || property === void 0 ? void 0 : property.status) && {
        propertyStatus: property === null || property === void 0 ? void 0 : property.status
    }, (property === null || property === void 0 ? void 0 : property.opendoorOwned) && {
        opendoorOwned: property === null || property === void 0 ? void 0 : property.opendoorOwned
    }, (property === null || property === void 0 ? void 0 : property.addressId) && {
        addressId: property === null || property === void 0 ? void 0 : property.addressId
    });
    var properties = _object_spread(_object_spread_props(_object_spread({}, additionalContextualData, trackPropertyFields), {
        anonymousId: getAnonymousId()
    }), (user === null || user === void 0 ? void 0 : user.customerUuid) && {
        customerId: user.customerUuid
    });
    // Filter out any keys where the value is empty
    var payload = Object.keys(properties).filter(function(key) {
        return properties[key];
    }).reduce(function(obj, key) {
        obj[key] = properties[key];
        return obj;
    }, {});
    return payload;
}
var useTrackProperty_useTrackProperty = function() {
    var analytics = useObservability();
    var property = usePropertyAnalytics().property;
    var user = useAuth().user;
    var trackProperty = useCallback(function(featureName, label) {
        var additionalContextualData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var action = featureName;
        var payload = buildPayload(property, additionalContextualData, user);
        analytics.trackEvent(action, label, payload);
        if (DEPLOY_ENV === "development") {
            console.debug("[Analytics]", {
                featureName: featureName,
                label: label,
                payload: payload
            });
        }
    }, [
        analytics.trackEvent,
        property
    ]);
    return {
        trackProperty: trackProperty
    };
};
/* harmony default export */ var properties_helpers_useTrackProperty = ((/* unused pure expression or super */ null && (useTrackProperty_useTrackProperty)));

;// CONCATENATED MODULE: ./src/components/properties/components/CoverImages.tsx

















var LARGE_HERO_SIZE_CONFIG = [
    {
        minWidth: foundations_breakpoints/* breakpoints.2 */.AV[2],
        maxWidth: foundations_breakpoints/* breakpoints.3 */.AV[3],
        preset: "3:2-md",
        presetScale: "2/3"
    },
    {
        minWidth: foundations_breakpoints/* breakpoints.3 */.AV[3],
        maxWidth: null,
        preset: "3:2-lg",
        presetScale: "2/3"
    }, 
];
var SMALL_HERO_SIZE_CONFIG = [
    {
        minWidth: foundations_breakpoints/* breakpoints.0 */.AV[0],
        maxWidth: foundations_breakpoints/* breakpoints.1 */.AV[1],
        preset: "3:2-xs"
    },
    {
        minWidth: foundations_breakpoints/* breakpoints.1 */.AV[1],
        maxWidth: foundations_breakpoints/* breakpoints.2 */.AV[2],
        preset: "3:2-sm"
    }, 
];
var LARGE_SECONDARY_SIZE_CONFIG = [
    {
        minWidth: foundations_breakpoints/* breakpoints.2 */.AV[2],
        maxWidth: foundations_breakpoints/* breakpoints.3 */.AV[3],
        preset: "3:2-md",
        presetScale: "1/3"
    },
    {
        minWidth: foundations_breakpoints/* breakpoints.3 */.AV[3],
        maxWidth: null,
        preset: "3:2-lg",
        presetScale: "1/3"
    }, 
];
// Homes Placeholder SVG
var FALLBACK_URL = "https://images.opendoor.com/source/s3/imgdrop-production/ce1501221958405990f1d0d7fe935c51.svg?preset=square-2048";
var LargeScreen = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var primaryImage = (ref4 = (ref = props.photos) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref4 !== void 0 ? ref4 : FALLBACK_URL;
    var ref5;
    var secondaryImageTop = (ref5 = (ref1 = props.photos) === null || ref1 === void 0 ? void 0 : ref1[1]) !== null && ref5 !== void 0 ? ref5 : FALLBACK_URL;
    var ref6;
    var secondaryImageBottom = (ref6 = (ref2 = props.photos) === null || ref2 === void 0 ? void 0 : ref2[2]) !== null && ref6 !== void 0 ? ref6 : FALLBACK_URL;
    var totalPhotos = (ref3 = props.photos) === null || ref3 === void 0 ? void 0 : ref3.length;
    return /*#__PURE__*/ _jsxs(Box, {
        display: [
            "none",
            null,
            "flex"
        ],
        as: "ul",
        listStyleType: "none",
        margin: "0",
        padding: "0",
        height: "440px",
        children: [
            /*#__PURE__*/ _jsx(Box, {
                as: "li",
                onClick: props.openModal,
                role: "button",
                width: [
                    "100%",
                    null,
                    "65%"
                ],
                paddingRight: 3,
                tabIndex: 0,
                children: generatePresetPictureSet({
                    photoUrl: primaryImage,
                    sizes: LARGE_HERO_SIZE_CONFIG,
                    debugImageSizes: Boolean(props.debugImageSizes),
                    radii: {
                        borderTopStartRadius: "roundedSmooth",
                        borderBottomStartRadius: "roundedSmooth",
                        borderTopEndRadius: [
                            "roundedSmooth",
                            null,
                            "none"
                        ],
                        borderBottomEndRadius: [
                            "roundedSmooth",
                            null,
                            "none",
                            "none"
                        ]
                    },
                    lazy: false,
                    preload: true
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                height: "100%",
                flexDirection: "column",
                width: "35%",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        onClick: props.openModal,
                        role: "button",
                        as: "li",
                        height: "50%",
                        paddingBottom: 2,
                        tabIndex: 0,
                        children: generatePresetPictureSet({
                            photoUrl: secondaryImageTop,
                            sizes: LARGE_SECONDARY_SIZE_CONFIG,
                            debugImageSizes: Boolean(props.debugImageSizes),
                            radii: {
                                borderTopEndRadius: "roundedSmooth"
                            },
                            lazy: false,
                            preload: true
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        as: "li",
                        onClick: props.openModal,
                        role: "button",
                        height: "50%",
                        paddingTop: 2,
                        position: "relative",
                        tabIndex: 0,
                        children: [
                            totalPhotos > 3 && /*#__PURE__*/ _jsx(Box, {
                                position: "absolute",
                                bottom: "0%",
                                right: "0%",
                                mb: "6",
                                mr: "6",
                                maxWidth: "75%",
                                children: /*#__PURE__*/ _jsxs(Button, {
                                    paddingY: "2",
                                    paddingX: "5",
                                    variant: "secondary",
                                    size: "sm",
                                    "aria-label": null,
                                    type: "button",
                                    onClick: props.openModal,
                                    analyticsName: "cosmos-pdp-large-view-all",
                                    children: [
                                        "View all ",
                                        totalPhotos,
                                        " photos"
                                    ]
                                })
                            }),
                            generatePresetPictureSet({
                                photoUrl: secondaryImageBottom,
                                sizes: LARGE_SECONDARY_SIZE_CONFIG,
                                debugImageSizes: Boolean(props.debugImageSizes),
                                radii: {
                                    borderBottomEndRadius: "roundedSmooth"
                                },
                                lazy: false,
                                preload: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var isInViewport = function(rect) {
    if (!rect) {
        return false;
    }
    return rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var SizedPhoto = function(props) {
    var photoOnViewChange = React.useCallback(function(inView) {
        if (props.idx === 0) {
            props.setFirstPhotoVisibility(inView);
        }
        if (props.idx === props.totalPhotos - 1) {
            props.setLastPhotoVisibility(inView);
        }
    }, []);
    return /*#__PURE__*/ _jsx(Box, {
        as: "li",
        minWidth: "100%",
        scrollSnapAlign: "center",
        position: "relative",
        onClick: function() {
            props.onPhotoClicked(props.idx);
        },
        ref: props.boxRef,
        role: "button",
        tabIndex: 0,
        children: /*#__PURE__*/ _jsx(InViewTrackerBox, {
            onViewChange: photoOnViewChange,
            threshold: 0.5,
            delay: 150,
            initialInView: props.idx === 0 ? true : false,
            skip: props.idx > 0 && props.idx < props.totalPhotos - 1,
            boxProps: {
                width: "100%",
                height: "100%"
            },
            children: generatePresetPictureSet({
                photoUrl: props.photo,
                sizes: props.sizes,
                debugImageSizes: Boolean(props.debugImageSizes),
                radii: {},
                lazy: props.idx !== 0,
                preload: props.preload
            })
        })
    });
};
var PhotoCarousel = function(props) {
    var photos = props.photos.length === 0 ? [
        FALLBACK_URL
    ] : props.photos.map(function(x) {
        return x || FALLBACK_URL;
    });
    // Keep all the slide refs in another ref so that
    var slideRefs = useRef(props.photos.map(function(_) {
        return /*#__PURE__*/ createRef();
    }));
    var ref = useState(true), firstPhotoVisible = ref[0], setFirstPhotoVisible = ref[1];
    var ref1 = useState(false), lastPhotoVisible = ref1[0], setLastPhotoVisible = ref1[1];
    var goToSlide = useCallback(function(direction) {
        var // scroll the next or previous into view if it exists
        ref, ref1;
        var nextUp;
        var allRefs = slideRefs.current;
        if (!allRefs) {
            return;
        }
        for(var i = 0; i < allRefs.length; i++){
            var element = allRefs[i].current;
            if (!element) {
                continue;
            }
            // find currently active element
            if (isInViewport(element.getBoundingClientRect())) {
                if (direction === "next" && i + 1 < allRefs.length) {
                    nextUp = i + 1;
                }
                if (direction === "previous" && i - 1 >= 0) {
                    nextUp = i - 1;
                }
                break;
            }
        }
        if (nextUp === undefined) {
            return;
        }
        (ref = allRefs[nextUp]) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
    }, [
        slideRefs
    ]);
    useEffect(function() {
        var ref, ref1, ref2;
        (ref = slideRefs.current) === null || ref === void 0 ? void 0 : (ref1 = ref[props.selectedSlide]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
    }, [
        props.selectedSlide,
        slideRefs
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SelectiveSpritesheet, {
                icons: [
                    ChevronLeft16,
                    ChevronRight16
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                width: "100%",
                height: "100%",
                position: "relative",
                overscrollBehaviorX: "contain",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        "aria-label": "Navigate previous",
                        variant: "icon",
                        position: "absolute",
                        analyticsName: "cosmos-properties-slide-back",
                        visibility: firstPhotoVisible ? "hidden" : "visible",
                        type: "button",
                        top: "50%",
                        left: "0%",
                        ml: "4",
                        transform: "translate(0%, -50%)",
                        background: "neutrals0",
                        shadow: "z1",
                        zIndex: "1",
                        tabIndex: -1,
                        onClick: function() {
                            goToSlide("previous");
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: "chevron-left",
                            color: "neutrals100",
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        // when you overscoll the container, don't continue the scroll outside
                        // of the container
                        overscrollBehaviorX: "none",
                        overflowY: "hidden",
                        as: "ul",
                        listStyleType: "none",
                        margin: "0",
                        padding: "0",
                        minHeight: "100%",
                        minWidth: "100%",
                        // Fix for webkit border radius issues
                        // https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
                        css: /*#__PURE__*/ css("-webkit-mask-image:-webkit-radial-gradient(white,black);"),
                        scrollSnapType: "x mandatory",
                        flexDirection: "row"
                    }, props.carouselRadii), {
                        children: photos.map(function(photo, i) {
                            return /*#__PURE__*/ _jsx(SizedPhoto, {
                                idx: i,
                                debugImageSizes: props.debugImageSizes,
                                sizes: props.sizes,
                                setFirstPhotoVisibility: setFirstPhotoVisible,
                                setLastPhotoVisibility: setLastPhotoVisible,
                                totalPhotos: photos.length,
                                photo: photo,
                                onPhotoClicked: props.onPhotoClicked,
                                boxRef: slideRefs.current[i],
                                preload: i === 0 && props.isHero
                            }, i);
                        })
                    })),
                    /*#__PURE__*/ _jsx(Button, {
                        "aria-label": "Navigate next",
                        variant: "icon",
                        position: "absolute",
                        analyticsName: "cosmos-properties-slide-forward",
                        visibility: lastPhotoVisible || photos.length === 1 ? "hidden" : "visible",
                        top: "50%",
                        right: "0%",
                        type: "button",
                        mr: "4",
                        background: "neutrals0",
                        transform: "translate(0%, -50%)",
                        shadow: "z1",
                        tabIndex: -1,
                        onClick: function() {
                            goToSlide("next");
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            name: "chevron-right",
                            color: "neutrals100",
                            size: 16
                        })
                    })
                ]
            })
        ]
    });
};
var groupImages = function(photos) {
    var groupedImages = [];
    for(var i = 0; i < photos.length; i++){
        if (i % 3 === 0) {
            groupedImages.push([
                {
                    photoUrl: photos[i],
                    photoIndex: i
                }
            ]);
        }
        if (i % 3 === 1) {
            groupedImages.push([
                {
                    photoUrl: photos[i],
                    photoIndex: i
                },
                {
                    photoUrl: photos === null || photos === void 0 ? void 0 : photos[i + 1],
                    photoIndex: i + 1
                }, 
            ].filter(function(x) {
                return Boolean(x.photoUrl);
            }));
            i = i + 1;
        }
    }
    return groupedImages;
};
var DESIRED_ASPECT_RATIO = (/* unused pure expression or super */ null && (3 / 2));
var SMALL_LIGHTBOX_IMAGE_RATIO = 0.5;
var pictureImageSetForValues = function(breakpoints, presets) {
    var presetScale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return breakpoints.map(function(b, i) {
        var ref;
        var presetScaleNonNull = (ref = presetScale === null || presetScale === void 0 ? void 0 : presetScale[i]) !== null && ref !== void 0 ? ref : undefined;
        var ref1;
        return {
            minWidth: b,
            maxWidth: (ref1 = breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints[i + 1]) !== null && ref1 !== void 0 ? ref1 : null,
            preset: presets[i],
            presetScale: presetScaleNonNull
        };
    });
};
var Lightbox = function(props) {
    var trackProperty = useTrackProperty().trackProperty;
    var groupedImages = groupImages(props.photos);
    var responsiveWidthScaleFactors = [
        100,
        100,
        35,
        25,
        25
    ];
    var presets = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].map(function(x) {
        return "3:2-".concat(x);
    });
    var widths = responsiveWidthScaleFactors.map(function(s) {
        return "".concat(s, "%");
    });
    var imageHeightSingle = responsiveWidthScaleFactors.map(function(s) {
        return "calc(".concat(s, "vw * ").concat(1 / DESIRED_ASPECT_RATIO, ")");
    });
    var imageHeightDouble = responsiveWidthScaleFactors.map(function(s) {
        return "calc(".concat(s, "vw * ").concat(1 / DESIRED_ASPECT_RATIO * SMALL_LIGHTBOX_IMAGE_RATIO, ")");
    });
    var pictureSetSingle = pictureImageSetForValues(breakpoints, presets, [
        null,
        null,
        "1/3",
        "1/4",
        "1/4", 
    ]);
    var pictureSetDouble = pictureImageSetForValues(breakpoints, presets, [
        "1/2",
        "1/2",
        "1/6",
        "1/8",
        "1/8", 
    ]);
    var pictureSetLargeCarousel = pictureImageSetForValues(breakpoints, presets);
    var ref = useState(false), isModalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = useState(0), selectedSlide = ref1[0], setSelectedSlide = ref1[1];
    // useDevice uses legacy breakpoints, however, isMobile maps correctly to the
    // eero breakpoints mobile device sizes
    var isMobile = useDevice().isMobile;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                analyticsName: "cosmos-property-lightbox-mobile-carousel-modal",
                "aria-label": "Photo viewer carousel",
                showClose: true,
                onRequestClose: function() {
                    return setModalOpen(false);
                },
                hasPadding: true,
                mobileSize: "sheet",
                isOpen: isMobile && isModalOpen,
                children: /*#__PURE__*/ _jsx(PhotoCarousel, _object_spread_props(_object_spread({}, props), {
                    onPhotoClicked: function(selectedSlide) {
                        trackProperty("property-images", "mobile-modal-image-click");
                        setSelectedSlide(selectedSlide);
                    },
                    selectedSlide: selectedSlide,
                    sizes: SMALL_HERO_SIZE_CONFIG,
                    carouselRadii: {
                        borderRadius: "roundedSmooth"
                    }
                }))
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                height: "100%",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        width: widths,
                        overflowY: "auto",
                        children: groupedImages.map(function(images, i) {
                            return /*#__PURE__*/ _jsx(Flex, {
                                flexDirection: "row",
                                mb: "3",
                                gap: "3",
                                width: "100%",
                                overflow: "hidden",
                                height: images.length === 2 ? imageHeightDouble : imageHeightSingle,
                                children: images.map(function(image, j) {
                                    var onClick = function() {
                                        trackProperty("property-images", "select-slide-image");
                                        setModalOpen(true);
                                        setSelectedSlide(image.photoIndex);
                                    };
                                    return /*#__PURE__*/ _jsx(Box, {
                                        role: "button",
                                        onKeyDown: function(e) {
                                            var keyD = e.key !== undefined ? e.key : e.keyCode;
                                            if (keyD === "Enter" || keyD === 13) {
                                                onClick();
                                            }
                                        },
                                        tabIndex: 0,
                                        onClick: onClick,
                                        children: generatePresetPictureSet({
                                            photoUrl: image.photoUrl,
                                            sizes: images.length === 2 ? pictureSetDouble : pictureSetSingle,
                                            debugImageSizes: Boolean(props.debugImageSizes),
                                            radii: {},
                                            lazy: true
                                        })
                                    }, "".concat(i, "-").concat(j));
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        display: [
                            "none",
                            null,
                            "flex"
                        ],
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "1440px",
                        mx: "auto",
                        children: /*#__PURE__*/ _jsx(Box, {
                            width: "100%",
                            paddingX: "8",
                            children: /*#__PURE__*/ _jsx(PhotoCarousel, _object_spread_props(_object_spread({}, props), {
                                onPhotoClicked: function(selectedSlide) {
                                    trackProperty("property-images", "desktop-image-carousel-click");
                                    setSelectedSlide(selectedSlide);
                                },
                                selectedSlide: selectedSlide,
                                sizes: pictureSetLargeCarousel,
                                carouselRadii: {
                                    borderRadius: "squared"
                                }
                            }))
                        })
                    })
                ]
            })
        ]
    });
};
// setModalElement is a storybook testing prop, skipping `setAppElement` in storybook fixes rendering issues
var CoverImages = function(props) {
    var ref = useState(props.isLightboxOpen), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var trackProperty = useTrackProperty().trackProperty;
    var openModal = useCallback(function() {
        setIsModalOpen(true);
        trackProperty("property-images", "open-modal");
    }, [
        setIsModalOpen
    ]);
    var closeModal = useCallback(function() {
        return setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    var isMobile = useDevice().isMobile;
    var formattedListPrice = typeof props.listPrice === "number" ? numberAsDollar(props.listPrice / 100) : null;
    useEffect(function() {
        if (props.setModalElement) {
            setAppElement("#__next");
        }
    }, []);
    var ref1 = getFormattedAddresses(props.address), shortAddress = ref1.short, fullAddress = ref1.full;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                analyticsName: "cosmos-property-lightbox-modal",
                showClose: true,
                onRequestClose: closeModal,
                headerProps: {
                    title: isMobile ? shortAddress : fullAddress,
                    leftComponent: /*#__PURE__*/ _jsx(Flex, {
                        gap: "2",
                        children: props.buttonCtas
                    }),
                    subtitle: formattedListPrice || undefined,
                    subtitleProps: {
                        marginTop: "0"
                    },
                    titleProps: {
                        marginBottom: "0",
                        overflowWrap: "break-word"
                    }
                },
                hasPadding: true,
                desktopAndTabletSize: "fullScreen",
                mobileSize: "fullScreen",
                isOpen: isModalOpen,
                children: /*#__PURE__*/ _jsx(Lightbox, _object_spread({}, props))
            }),
            /*#__PURE__*/ _jsxs(Box, {
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ _jsx(LargeScreen, _object_spread_props(_object_spread({}, props), {
                        openModal: openModal
                    })),
                    /*#__PURE__*/ _jsx(Box, {
                        display: [
                            "flex",
                            null,
                            "none"
                        ],
                        children: /*#__PURE__*/ _jsx(PhotoCarousel, _object_spread_props(_object_spread({}, props), {
                            onPhotoClicked: function() {
                                openModal();
                            },
                            selectedSlide: 0,
                            sizes: SMALL_HERO_SIZE_CONFIG,
                            carouselRadii: {
                                borderRadius: "none"
                            },
                            isHero: true
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CoverImages = ((/* unused pure expression or super */ null && (CoverImages)));

;// CONCATENATED MODULE: ./src/components/properties/helpers/property.ts


var getMonthlyHoaFee = function(hoaFeeAmount, hoaFeeFrequency) {
    if (!hoaFeeAmount || !hoaFeeFrequency) {
        return;
    }
    if (hoaFeeFrequency === "monthly") {
        return hoaFeeAmount;
    }
    if (hoaFeeFrequency === "annually") {
        return Math.round(hoaFeeAmount / 12);
    }
    return;
};
var calculateTotalBathrooms = function(bathroomsFull, bathroomsHalf) {
    var totalBathrooms = 0;
    if (bathroomsFull) {
        totalBathrooms += bathroomsFull;
    }
    if (bathroomsHalf) {
        totalBathrooms += Math.round(bathroomsHalf * 0.5);
    }
    return totalBathrooms;
};
function getHumanReadableAddress(street, city, state, postalCode) {
    if (!street || !city || !state || !postalCode) {
        return "";
    }
    return "".concat(street, ", ").concat(city, ", ").concat(state, " ").concat(postalCode);
}
var property_getFormattedAddresses = function(props) {
    return {
        short: [
            props.street,
            props.unitNumber && "#".concat(props.unitNumber)
        ].filter(Boolean).join(" "),
        full: [
            props.street,
            props.unitNumber && "#".concat(props.unitNumber),
            (props.city || props.state) && [
                props.city,
                props.state
            ].filter(Boolean).join(", "),
            props.postalCode, 
        ].filter(Boolean).join(" ")
    };
};
var getReadableDwellingType = function(dwellingType) {
    if (!dwellingType) {
        return "Unknown";
    }
    return dwellingType === null || dwellingType === void 0 ? void 0 : dwellingType.split("_").map(function(input) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }).join(" ");
};
var getReadableListingStatus = function(listingState) {
    if (!listingState) {
        return "Unknown";
    }
    if (listingState === "SELL_REQUEST_TEMP_OFF_MARKET") {
        return "Off Market";
    }
    return listingState.substring("SELL_REQUEST_".length).split("_").map(function(input) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }).join(" ");
};
var getReadableHoaFeatures = function(monthlyHoaFee, features) {
    if (!monthlyHoaFee || !features || (features === null || features === void 0 ? void 0 : features.length) === 0) {
        return undefined;
    }
    return "$".concat(monthlyHoaFee, " includes: ").concat(features.map(function(item) {
        return "".concat(item === null || item === void 0 ? void 0 : item.replace(/([A-Z])/g, " $1").toLowerCase());
    }));
};
var getSeoFields = function(addressId, displaySlug, status, street, unitNumber, city, state, postalCode, sqFtLot, bedrooms, bathrooms, yearBuilt, coverImageProp) {
    var ref;
    var readableAddress = getHumanReadableAddress(street, city, state, postalCode);
    var title = "Home for sale - ".concat(readableAddress, " | Opendoor");
    var canonicalUrl = displaySlug ? "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(displaySlug, "/aid_").concat(addressId) : "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(street ? "".concat((ref = street === null || street === void 0 ? void 0 : street.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "-"), "-") : "").concat(unitNumber ? "".concat(unitNumber, "-") : "").concat(city ? "".concat(city === null || city === void 0 ? void 0 : city.toLowerCase(), "-") : "", "-").concat(state === null || state === void 0 ? void 0 : state.toLowerCase()).concat(postalCode, "/aid_").concat(addressId);
    var forSale = getReadableListingStatus(status) === "Active";
    var metaDescription = "".concat(readableAddress, " is currently ").concat(forSale ? "for sale" : "not for sale", ". The ").concat(sqFtLot ? "".concat(sqFtLot, " sq ft.") : "", " home ").concat(yearBuilt ? "was built in ".concat(yearBuilt) : "", " ").concat(bedrooms ? "and has ".concat(bedrooms, " bedrooms") : "", " ").concat(bathrooms ? "and has ".concat(bathrooms, " bathrooms") : "", ". Learn more about the home on Opendoor.");
    var coverImage = FALLBACK_URL;
    if (coverImageProp) {
        coverImage = "".concat(coverImageProp, "?").concat(new URLSearchParams({
            preset: "3:2-sm",
            service: "cosmos"
        }).toString());
    }
    return {
        readableAddress: readableAddress,
        canonicalUrl: canonicalUrl,
        metaDescription: metaDescription,
        title: title,
        coverImage: coverImage
    };
};
var getBuyerAgentCommissionAmountFormatted = function(type, value) {
    if (!value || !type) {
        return "";
    }
    return type === "RATE_BPS" ? "".concat(value / 100, "%") : "$".concat(value / 100);
};
var buyerAgentCommissionModalHeader = "What’s this mean?";
var buyerAgentCommissionModalBody = "The seller pays a fee to their agent when the home sells. And they’ve agreed to share part of that commission with the buyer’s agent or their brokerage. To get that commission, they have to be a member of the MLS.";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/properties/shared/SeoHead.tsx
/* storybook-check-ignore */ 



var getBaseTags = function(props) {
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
            children: props.title
        }, "title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "description",
            content: props.metaDescription
        }, "description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "author",
            content: props.author
        }, "author"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: props.canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, siteName = props.siteName, type = props.type;
    var tags = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"), 
    ];
    return tags;
};
var getPropertySchemaData = function(props) {
    var address = props.address, floorSize = props.floorSize, listPrice = props.listPrice, url = props.url, lat = props.lat, lon = props.lon, hasSelfTour = props.hasSelfTour, addressToken = props.addressToken, remainingProps = (0,src_object_without_properties/* default */.Z)(props, [
        "address",
        "floorSize",
        "listPrice",
        "url",
        "lat",
        "lon",
        "hasSelfTour",
        "addressToken"
    ]);
    var schemaData = (0,src_object_spread/* default */.Z)({
        "@context": "https://schema.org/",
        "@type": [
            "SingleFamilyResidence",
            "Product"
        ]
    }, address && {
        address: (0,src_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address)
    }, lat && lon && {
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lon
        }
    }, floorSize && {
        floorSize: (0,src_object_spread/* default */.Z)({
            "@type": "QuantitativeValue"
        }, floorSize)
    }, hasSelfTour && addressToken && {
        tourBookingPage: "https://consumer.opendoor.com/dashboard/buy/tour?id=".concat(addressToken)
    }, listPrice && url && {
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: listPrice,
            url: url,
            availability: "http://schema.org/InStock"
        }
    }, remainingProps);
    return schemaData;
};
var SeoHead = function(props) {
    var base = props.base, og = props.og, schema = props.schema;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            getBaseTags(base),
            getOgTags(og),
            schema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getPropertySchemaData(schema))
                }
            })
        ]
    });
};
/* harmony default export */ var shared_SeoHead = (SeoHead);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
;// CONCATENATED MODULE: ./src/components/properties/shared/MarketplaceLayout.tsx
/* storybook-check-ignore */ 











var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Home insights",
        href: "/home-insights"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceLayout = function(param) {
    var children = param.children, property = param.property;
    var ref;
    var ref1 = getSeoFields(property === null || property === void 0 ? void 0 : property.addressToken, property === null || property === void 0 ? void 0 : property.slug, undefined, property === null || property === void 0 ? void 0 : property.street, property === null || property === void 0 ? void 0 : property.unitNumber, property === null || property === void 0 ? void 0 : property.city, property === null || property === void 0 ? void 0 : property.state, property === null || property === void 0 ? void 0 : property.zip, property === null || property === void 0 ? void 0 : property.sqFtLot, property === null || property === void 0 ? void 0 : property.bedrooms, property === null || property === void 0 ? void 0 : property.bathrooms, property === null || property === void 0 ? void 0 : property.yearBuilt, property === null || property === void 0 ? void 0 : (ref = property.photos) === null || ref === void 0 ? void 0 : ref[0]), coverImage = ref1.coverImage, readableAddress = ref1.readableAddress, title = ref1.title, canonicalUrl = ref1.canonicalUrl;
    var metaDescription = "View photos, details, and schedule a self-tour of this ".concat(property === null || property === void 0 ? void 0 : property.bedrooms, " bedroom, ").concat(property === null || property === void 0 ? void 0 : property.bathrooms, " bathroom, ").concat(property === null || property === void 0 ? void 0 : property.sqFtTotalLiving, " sqft home located at ").concat(readableAddress, ".");
    var seoHead = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SeoHead, {
        base: {
            title: title,
            author: "Opendoor, Inc.",
            metaDescription: metaDescription,
            canonicalUrl: canonicalUrl
        },
        og: {
            url: canonicalUrl,
            title: title,
            description: metaDescription,
            siteName: "Opendoor",
            image: coverImage,
            type: "website"
        },
        schema: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: readableAddress,
            description: metaDescription,
            url: canonicalUrl,
            address: (0,src_object_spread/* default */.Z)({}, (property === null || property === void 0 ? void 0 : property.street) && {
                streetAddress: property.street
            }, (property === null || property === void 0 ? void 0 : property.city) && {
                addressLocality: property.city
            }, (property === null || property === void 0 ? void 0 : property.state) && {
                addressRegion: property.state
            }, (property === null || property === void 0 ? void 0 : property.zip) && {
                postalCode: property.zip
            })
        }, (property === null || property === void 0 ? void 0 : property.sqFtLot) && {
            floorSize: {
                value: property.sqFtLot.toString()
            }
        }, (property === null || property === void 0 ? void 0 : property.yearBuilt) && {
            yearBuilt: property.yearBuilt.toString()
        }, (property === null || property === void 0 ? void 0 : property.bedrooms) && {
            numberOfBedrooms: property.bedrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.bathrooms) && {
            numberOfBathroomsTotal: property.bathrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.listPrice) && !(0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.listPrice
        }, (property === null || property === void 0 ? void 0 : property.buyDirectPrice) && (0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.buyDirectPrice
        }), {
            image: coverImage,
            lat: property === null || property === void 0 ? void 0 : property.latitude,
            lon: property === null || property === void 0 ? void 0 : property.longitude
        }), (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
            hasSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
        }), {
            addressToken: property === null || property === void 0 ? void 0 : property.addressToken
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "marketplace",
        launchDateString: new Date().toISOString(),
        overrides: {},
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    })
                ]
            }),
            seoHead,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
                flexDirection: "column",
                backgroundColor: "$backgroundPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                        display: "block",
                        width: "100%",
                        zIndex: 2,
                        style: {
                            position: "fixed"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                            slug: "homes",
                            mainNavLinks: mainNavLinks,
                            menuPanelNavLinks: menuPanelNavLinks
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                        tag: "main",
                        tabIndex: -1,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        overflowX: "hidden",
                        backgroundColor: "$backgroundPrimary",
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_MarketplaceLayout = (MarketplaceLayout);

;// CONCATENATED MODULE: ./src/pages/marketplace/_internal/for-sale/[address_id].tsx











var Page = function(props) {
    var property = props === null || props === void 0 ? void 0 : props.property;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(helpers_useTrackProperty/* PropertyAnalytics.Provider */.KV.Provider, {
        value: {
            property: property
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageInner, (0,src_object_spread/* default */.Z)({}, props))
    });
};
var PageInner = function(param) {
    var property = param.property;
    var trackProperty = (0,helpers_useTrackProperty/* default */.ZP)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var ref = (0,react.useState)(false), isLightboxOpen = ref[0], setIsLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(false), isShareModalOpen = ref1[0], setIsShareModalOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var toggleLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(function(prev) {
            return !prev;
        });
    }, []);
    var handleSetSelectedPhotoIndex = (0,react.useCallback)(function(idx) {
        return setSelectedPhotoIndex(idx);
    }, []);
    var ref3 = (0,helpers/* usePropertyReactions */.O8)(property.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref3.isLiked, onClickReaction = ref3.onClickReaction;
    /**
   * The initial page load for customers will include the cached similar properties.
   * This hook executes client-side to retrieve the latest similar listings.
   */ var marketplaceProperty = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, property), {
        isLiked: isLiked,
        onClickReaction: onClickReaction
    });
    var similarProperties = (0,helpers/* useSimilarProperties */.n6)(property.addressToken).similarProperties;
    if (similarProperties === null || similarProperties === void 0 ? void 0 : similarProperties.results) {
        marketplaceProperty.similarProperties = similarProperties;
    }
    var sellerDisclosures = (0,helpers/* useSellerDisclosures */.FZ)(property.addressToken).sellerDisclosures;
    if (sellerDisclosures) {
        marketplaceProperty.sellerDisclosuresDownloadUrl = sellerDisclosures;
    }
    (0,react.useEffect)(function() {
        trackProperty("property-view", "marketplace-pdp");
        trackJourneyEvent("marketplaceProperty", "detailPageView", {
            addressUuid: property.addressToken
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(shared_MarketplaceLayout, {
        property: marketplaceProperty,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spritesheet/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                $smallerThanMD: {
                    flexDirection: "column",
                    overflowY: "scroll"
                },
                $largerThanSM: {
                    flexDirection: "row",
                    height: "100vh"
                },
                overflow: "hidden",
                width: "100vw",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* GalleryPhotos */.Ub, {
                        handleSetSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                        property: marketplaceProperty,
                        toggleLightbox: toggleLightbox
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PhotoCarousel */.cS, {
                        photos: marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.photos,
                        price: (marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.displayBadge) === "ON_THE_MARKET" && (0,helpers/* isBuyDirectEligible */.pX)(marketplaceProperty) ? marketplaceProperty.buyDirectPrice : marketplaceProperty.listPrice,
                        address: marketplaceProperty.street,
                        toggleLightbox: toggleLightbox,
                        setSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                        latitude: marketplaceProperty.latitude,
                        longitude: marketplaceProperty.longitude,
                        openShareModal: function() {
                            return setIsShareModalOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* Lightbox */.ey, {
                        handleClose: toggleLightbox,
                        isOpen: isLightboxOpen,
                        property: marketplaceProperty,
                        selectedPhotoIndex: selectedPhotoIndex
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PropertySection */.qH, {
                        property: marketplaceProperty
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                        property: marketplaceProperty,
                        isOpen: isShareModalOpen,
                        onClose: function() {
                            return setIsShareModalOpen(false);
                        }
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _address_id_ = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,9842,2767,6500,5662,7166,3089,4638,9331,523,4897,7014,7194,5369,2864,4370,2774,7535,8111,6824,8058,2149,4141,9774,2888,179], function() { return __webpack_exec__(23201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);